import { StandaloneSearchPage } from './StandaloneSearchPage';

export { StandaloneSearchPage };
export default StandaloneSearchPage;
